import BaseService from "./core/BaseService";
import HttpService from "./core/HttpService";
import TokenService from "./core/TokenService";
import { post } from "axios";

class AuthService extends BaseService {
  async login(credentials) {
    const {
      data: { token },
    } = await this.post("/login", credentials);

    // Save token
    TokenService.setToken(token);

    // Configure HttpClient with the new token
    HttpService.setAuthorizationHeader(token);
    HttpService.mount401Interceptor();

    return token;
  }

  async loginWithSnapchat(token) {
    // Save token
    TokenService.setToken(token);

    // Configure HttpClient with the new token
    HttpService.setAuthorizationHeader(token);
    HttpService.mount401Interceptor();

    return;
  }

  async register(user) {
    const {
      data: { data },
    } = await this.post("/register", user);
    return data;
  }

  async sendPasswordResetNotification(email) {
    const { data } = await this.post("/password/email", { email });
    return data;
  }

  async updatePassword(user) {
    const { data } = await this.post("/password/reset", user);
    return data;
  }

  logout() {
    // Remove token from cookies
    TokenService.removeToken();

    // Remove all traces of the token
    HttpService.removeAuthorizationHeader();
    HttpService.unmount401Interceptor();
  }

  // Snapchat

  async verifyEmailWithSnapchat(email) {
    const { data } = await post(
      process.env.VUE_APP_SNAPCHAT_EMAIL_CONFIRM_API_URL,
      {
        email,
      }
    );

    return data;
  }

  async confirmAccountWithSnapchat(credentials) {
    const { data } = await post(
      process.env.VUE_APP_SNAPCHAT_ACCOUNT_CONFIRM_API_URL,
      credentials
    );

    return data;
  }
}

export default new AuthService();
